import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import {sendClientSms} from "../common/api/WebApi";

export default function ComposeSms({client, show, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);
  const [saving, setSaving] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(client)
  });

  const handleCloseNote = () => {
    handleClose();
  };

  const handleSendSms = (data) => {
    let message = {...data};
    message.client = client;
    setSaving(true);
    sendClientSms(message).then((resp)=> {
      setSaving(false);
      handleSave(data);
    });
  };

  return (
    <Modal onHide={handleCloseNote} size={'lg'} show={show}>
      <form
        onSubmit={handleSubmit(handleSendSms)} id={'noteForm'}>
        <Modal.Header closeButton>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <textarea required
                                rows={15}
                                {...register('message')}
                                className="form-control" id="message"
                                placeholder="Enter Message"/>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}